export const valuedEn = {
  title: 'Adde Valued Services',
  description: 'A variety of guarantee services, offering thorough and reliable protection.',
  list: [
    {
      title: 'Environmental Construction and Hazardous Removal',
      description:
        'Experts in hazardous material removal, including asbestos and lead abatement, meeting compliance with EPA, AQMD, OSHA, and city codes.',
    },
    {
      title: 'General Construction',
      description: 'Comprehensive building and development services',
    },
    {
      title: 'Flooring and Waterproofing Solutions',
      description:
        'Specialists in epoxy flooring, antimicrobial flooring, and advanced waterproofing systems, protect structures from moisture intrusion and extend lifespan.',
    },
    {
      title: 'Disaster Relief and Restoration',
      description:
        'Skilled in fire and smoke damage restoration, water damage restoration, microbial remediation, and biohazard remediation.',
    },
  ],
}
